import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IPath } from '@obvious.tech/constellation'

export const Path = defineEntity('Path', {
  endpoint: 'navigation/api/Path/duration',
  schema: SNoop<IPath>(),
})
